import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Button } from "../components/ui/button";
import Navbar from "../components/layout/Navbar";

export default function BankDetailsPage() {
  const navigate = useNavigate();
  const { method, reference } = useParams();
  const { customerDetails, cart } = useLocation().state || {};

  const totalAmount = cart ? cart.reduce(
    (sum, item) => sum + item.price * item.quantity,
    0
  ) : 0;

  const bankDetails = {
    monnify: {
      bankName: "Monnify Bank",
      accountNumber: "1234567890",
      bankCode: "MON123",
      instructions: "Please make a payment to the following bank account and use the reference number provided. Once payment is confirmed, you will receive a confirmation.",
    },
    bank_transfer: {
      bankName: "Your Bank Name",
      accountNumber: "0987654321",
      bankCode: "BANK456",
      instructions: "Transfer the total amount to the bank account below using the reference number. Payment will be confirmed within 24-48 hours.",
    },
  };

  const details = bankDetails[method] || {};

  const handleConfirmPayment = () => {
    navigate("/payment-success", {
      state: {
        paymentData: { reference },
        customerDetails,
        cart,
      },
    });
  };

  return (
    <section className="w-full min-h-screen bg-[#0b081d] text-white flex items-center justify-center py-30">
      <Navbar />
      <div className="max-w-3xl w-full px-6">
        <h1 className="text-3xl sm:text-4xl font-bold mb-6 text-center">
          {method === "monnify" ? "Monnify Payment Instructions" : "Bank Transfer Instructions"}
        </h1>
        <div className="bg-gray-900 rounded-lg p-6 mb-6">
          <h2 className="text-xl font-semibold mb-4">Payment Details</h2>
          <p><strong>Bank Name:</strong> {details.bankName || "N/A"}</p>
          <p><strong>Account Number:</strong> {details.accountNumber || "N/A"}</p>
          <p><strong>Bank Code:</strong> {details.bankCode || "N/A"}</p>
          <p><strong>Reference Number:</strong> {reference || "N/A"}</p>
          <p><strong>Amount to Pay:</strong> ₦{totalAmount.toFixed(2)}</p>
          <p className="mt-4"><strong>Instructions:</strong> {details.instructions || "N/A"}</p>
          <h3 className="text-lg font-semibold mt-4 mb-2">Items to be Paid</h3>
          <ul className="space-y-2">
            {cart && cart.map((item) => (
              <li key={item.id}>
                {item.name} (Qty: {item.quantity}) - ₦{(item.price * item.quantity).toFixed(2)}
              </li>
            ))}
          </ul>
        </div>
        <div className="text-center">
          <Button
            onClick={handleConfirmPayment}
            className="bg-blue-600 hover:bg-blue-700 text-white"
          >
            Confirm Payment
          </Button>
          <Button
            onClick={() => navigate("/receipt")}
            className="bg-gray-600 hover:bg-gray-700 text-white ml-4"
          >
            Back to Payment
          </Button>
        </div>
      </div>
    </section>
  );
}